import { FunctionComponent } from 'react';
import { elementSizeAtomFam } from 'packages/lib/common-ui/state';
import {
  contentAreaId,
  footerAreaId,
  primaryViewAreaId,
  siderAreaId,
} from 'packages/at-shell/components/app-shell/app-layout-constants';
import { useRecoilValue } from 'recoil';

export const PrimaryViewAreaStyles: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const contentAreaSize = useRecoilValue(elementSizeAtomFam(contentAreaId));
  const siderAreaSize = useRecoilValue(elementSizeAtomFam(siderAreaId));
  const footerAreaSize = useRecoilValue(elementSizeAtomFam(footerAreaId));

  if (!contentAreaSize) {
    return (
      <style>{`
        #${primaryViewAreaId} {
          width: 100%;
          height: 100%;
        }
        `}</style>
    );
  }
  const width = contentAreaSize.width - (siderAreaSize?.width ?? 0);
  const height = contentAreaSize.height - (footerAreaSize?.height ?? 0);
  return (
    <style>{`
        #${primaryViewAreaId} {
          position: relative;
          width: ${width}px;
          height: ${height}px;
        }
        `}</style>
  );
};
